import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import components1 from "./1";
import components2 from "./2";
import components31 from "./3-1";
import components32 from "./3-2";
import components33 from "./3-3";
// import components34 from './3-4'
import components35 from "./3-5";
// import components36 from './3-6'
import components37 from "./3-7";
import components38 from "./3-8";
import components39 from "./3-9";
import components310 from "./3-10";
// import components311 from './3-11'
import components312 from "./3-12";
// import components313 from './3-13'
// import components316 from './3-16'
import components317 from "./3-17";
// import components318 from './3-18'
import components319 from "./3-19";
import components321 from "./3-21";
import components325 from "./3-25";
import components326 from "./3-26";
import components327 from "./3-27";
import components328 from "./3-28";
import components329 from "./3-29";
import components330 from "./3-30";
import components331 from "./3-31";
import components332 from "./3-32";
import components333 from "./3-33";
import components334 from "./3-34";
import components335 from "./3-35";
import components336 from "./3-36";
import components4 from "./4";
var config = {
  One: components1,
  Two: components2,
  ThreeOne: components31,
  ThreeTwo: components32,
  ThreeThree: components33,
  // 'ThreeFour': components34,
  ThreeFive: components35,
  // 'ThreeSix': components36,
  ThreeSeven: components37,
  ThreeEight: components38,
  ThreeNine: components39,
  ThreeOneZero: components310,
  // 'ThreeOneOne': components311,
  ThreeOneTwo: components312,
  // 'ThreeOneThree': components313,
  // 'ThreeOneFour' : components314,
  // 'ThreeOneFive' : components315,
  // 'ThreeOneSix': components316,
  ThreeOneSeven: components317,
  // 'ThreeOneEight': components318,
  ThreeOneNine: components319,
  ThreeTwoOne: components321,
  // 'ThreeTwoFour' : components324,
  ThreeTwoFive: components325,
  ThreeTwoSix: components326,
  ThreeTwoSeven: components327,
  ThreeTwoEight: components328,
  ThreeTwoNine: components329,
  ThreeThreeZero: components330,
  ThreeThreeOne: components331,
  ThreeThreeTwo: components332,
  ThreeThreeThree: components333,
  ThreeThreeFour: components334,
  ThreeThreeFive: components335,
  ThreeThreeSix: components336,
  Four: components4
};
function install(Vue) {
  Object.keys(config).map(function (key) {
    Vue.component(key, config[key]);
  });
}
export default {
  install: install
};
// ['Zero','One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten']